import { ISelectOption } from '../interfaces';

import { RELEVANCES } from './date';

export const interceptionRelevanceOptions: ISelectOption[] = [
  { label: 'За час', value: RELEVANCES.ONE_HOUR },
  { label: 'За 2 часа', value: RELEVANCES.TWO_HOURS },
  { label: 'За 4 часа', value: RELEVANCES.FOUR_HOURS },
  { label: 'За 8 часов', value: RELEVANCES.EIGHT_HOURS },
  { label: 'За 12 часов', value: RELEVANCES.TWELVE_HOURS },
  { label: 'За день', value: RELEVANCES.ONE_DAY },
  { label: 'За три дня', value: RELEVANCES.THREE_DAYS },
  { label: 'За неделю', value: RELEVANCES.ONE_WEEK },
  { label: 'За все время', value: RELEVANCES.ALL_TIME },
];
